import styled from '../../../../styles/styledComponents/themeComponents';

export const TabListPreviewStyle = styled.div`
  .widget-preview-title {
    padding: 0;
  }
`;

export const TabHeaderStyle = styled.div`
  .indiana-scroll-container {
    border-bottom: 1px solid #e5e5e5;
  }
`;

export const TabHeaderListStyle = styled.ul`
  display: flex;
  margin-bottom: 0;

  .swiper-slide {
    width: auto;
  }

  .item {
    width: fit-content;
    padding: 0 16px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    -webkit-text-size-adjust: none;
    color: #9b9b9b;
    white-space: nowrap;

    &.active > span {
      color: #000000;
      border-bottom: 2px solid #000000;
    }

    & > span {
      display: block;
      padding: 11px 0 9px 0;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: -0.4px;
      font-weight: bold;
    }
  }
`;
